import pluralize from "pluralize"
import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"

import ReloadableWidget from "src/components/ReloadableWidget"
import TrackingLink from "src/components/TrackingLink"

import { queryCancellationRequests } from "src/api/Dashboard"

import DashboardTooltip from "./DashboardTooltip"

const refreshRate = 300 * 1000 // 5 minutes

const renderData = (count) => {
  if (count > 0) {
    return (
      <div className="flex flex-col">
        <div className="mb-2 flex">
          <i className="icon icon-event-busy mr-2 text-xl" />
          <span className="mr-1 text-xl font-bold">{count}</span>
        </div>
        <span>{pluralize("cancellation", count)}</span>
      </div>
    )
  } else {
    return (
      <div className="flex items-center">
        <i className="icon icon-event-busy mr-2 text-xl" />
        <span>No cancellations</span>
      </div>
    )
  }
}

const CancellationRequests = ({ marinaSlug }) => {
  const { isLoading, isError, data } = useQuery(
    ["cancellationRequests", marinaSlug],
    () => queryCancellationRequests(marinaSlug),
    { retry: false, refetchInterval: refreshRate, refetchOnWindowFocus: false }
  )

  return (
    <ReloadableWidget isLoading={isLoading} isError={isError}>
      {data && (
        <TrackingLink
          href={data.cancellationRequestsLink}
          className="card relative flex w-full items-center justify-between p-6 text-center text-gray-900 no-underline hover:border-blue-800 hover:bg-blue-50 hover:text-blue-700"
          eventName="cancellation_requests_widget:clicked"
        >
          <DashboardTooltip />
          {renderData(data.cancellationRequestsCount)}
          <i className="icon icon-sf-chevron-right mt-0.5 text-xs font-semibold" />
        </TrackingLink>
      )}
    </ReloadableWidget>
  )
}

CancellationRequests.propTypes = {
  marinaSlug: PropTypes.string.isRequired,
}

export default CancellationRequests
